import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
    meta: { title: '首页 - Archeaux Studio' }
  },
  {
    path: '/products',
    name: 'Products',
    component: () => import('@/views/Products.vue'),
    meta: { title: '产品介绍 - Archeaux Studio' }
  },
  {
    path: '/products/children',
    name: 'ProductChildren',
    component: () => import('@/views/ProductChildren.vue'),
    meta: { title: '小元基 - Archeaux Studio' }
  },
  {
    path: '/products/youth',
    name: 'ProductYouth',
    component: () => import('@/views/ProductYouth.vue'),
    meta: { title: 'Élément - Archeaux Studio' }
  },
  {
    path: '/products/elderly',
    name: 'ProductElderly',
    component: () => import('@/views/ProductElderly.vue'),
    meta: { title: '守望者 - Archeaux Studio' }
  },
  {
    path: '/products/:productCode',
    name: 'ProductDetail',
    component: () => import('@/views/ProductDetail.vue'),
    meta: { title: '产品详情 - Archeaux Studio' }
  },
  {
    path: '/technology',
    name: 'Technology',
    component: () => import('@/views/Technology.vue'),
    meta: { title: '技术引擎 - Archeaux Studio' }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/About.vue'),
    meta: { title: '关于我们 - Archeaux Studio' }
  },
  {
    path: '/news',
    name: 'News',
    component: () => import('@/views/News.vue'),
    meta: { title: '新闻动态 - Archeaux Studio' }
  },
  {
    path: '/news/:id',
    name: 'NewsDetail',
    component: () => import('@/views/NewsDetail.vue'),
    meta: { title: '新闻详情 - Archeaux Studio' }
  },
  {
    path: '/cooperation',
    name: 'Cooperation',
    component: () => import('@/views/Cooperation.vue'),
    meta: { title: '商务合作 - Archeaux Studio' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  }
})

router.afterEach((to) => {
  document.title = (to.meta && to.meta.title) || 'Archeaux Studio'
})

export default router
